import { render } from "./OrderBackCustormerInfo.vue?vue&type=template&id=615b0412"
import script from "./OrderBackCustormerInfo.vue?vue&type=script&lang=js"
export * from "./OrderBackCustormerInfo.vue?vue&type=script&lang=js"

import "./OrderBackCustormerInfo.vue?vue&type=style&index=0&id=615b0412&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__